import { render, staticRenderFns } from "./agentManagement.vue?vue&type=template&id=b838c0d6"
import script from "./agentManagement.vue?vue&type=script&lang=js"
export * from "./agentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports